import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import SVG from 'react-inlinesvg';
import inView from 'in-view';
import {
  Image,
  Icon,
  Odometer,
  SectionHeader,
  Link,
  Loader,
} from 'components';
import './Statistics.scss';
import { ICON_TYPES } from 'config';
import { isResolution } from 'config/helpers';
import world from 'assets/images/statistics/world.svg';

class Statistics extends Component {
  handleSVGLoaded = () => {
    inView('.statistics__clients').on('enter', () => {
      if (typeof document !== 'undefined') {
        setTimeout(
          () =>
            document
              .getElementsByClassName('statistics__background')[0]
              .classList.add('launch-line'),
          2000,
        );
        setTimeout(
          () =>
            document
              .getElementsByClassName('statistics__background')[0]
              .classList.add('launch-dots'),
          2400,
        );
      }
    });
  };

  render() {
    if (
      typeof document !== 'undefined' &&
      document.querySelector('.world-map svg') &&
      isResolution(768)
    ) {
      document
        .querySelector('.world-map svg')
        .setAttribute('viewBox', '150 100 625 505');
    }

    return (
      <StaticQuery
        query={graphql`
          query {
            worldPlaceholder: file(
              relativePath: { eq: "statistics/world-placeholder.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 925) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={data => (
          <div className={'statistics__container'}>
            <div className={'statistics__background'}>
              <LazyLoad once offset={800} height={800}>
                <SVG
                  src={world}
                  className={'world-map'}
                  preloader={<Loader isActive absolute />}
                  onLoad={this.handleSVGLoaded}
                >
                  <Image
                    src={data.worldPlaceholder.childImageSharp.fluid}
                    alt={'Boldare World Clients'}
                  />
                </SVG>
              </LazyLoad>

              <div className={'statistics__clients'}>
                <span
                  className={'statistics__number statistics__number--large'}
                >
                  <Odometer value={89} uniqueID={'clients-counter'} />
                </span>
                <span className={'statistics__odometer-caption text--yellow'}>
                  clients
                </span>
              </div>
            </div>
            <div className={'statistics__header'}>
              <div className={'statistics__heading'}>
                <p className={'statistics__subtitle text--white'}>
                  Since <span className={'text--yellow'}>2004</span> we have
                </p>
                <br className={'hide-mobile'} />
                <SectionHeader
                  color={'white'}
                  lineColor={'white'}
                  size={'medium'}
                >
                  innovated globally
                </SectionHeader>
              </div>
              <div className={'statistics__products'}>
                <div className={'statistics__counter text--white'}>
                  <span
                    className={
                      'statistics__counter-caption statistics__counter-caption--big'
                    }
                  >
                    +&nbsp;
                  </span>
                  <span className={'statistics__number text--yellow'}>
                    250
                  </span>
                  <span
                    className={
                      'statistics__counter-caption statistics__counter-caption--big'
                    }
                  >
                    digital <strong>products</strong>
                  </span>
                </div>
              </div>
            </div>
            <div className={'statistics__content'}>
              <blockquote className={'statistics__quote'}>
                <Icon icon={ICON_TYPES.APOSTROPHE} color={'violet'} />
                <br />
                We believe that&nbsp;
                <strong>
                  the intersection
                  <br /> of humanism and computer
                  <br /> science
                </strong>
                &nbsp; is where great
                <br /> products happen
              </blockquote>
            </div>
            <div className={'statistics__footer'}>
              <div className={'statistics__info'}>
                <div className={'statistics__counter text--violet'}>
                  <span className={'statistics__number'}>14</span>
                  <span className={'statistics__counter-caption'}>
                    <strong>years</strong>&nbsp;of
                    <br />
                    experience
                  </span>
                </div>
                <div className={'statistics__counter text--violet'}>
                  <span className={'statistics__icon'}>
                    <Icon icon={ICON_TYPES.LIGHT_BULB} color={'violet'} />
                  </span>
                  <span className={'statistics__counter-caption'}>
                    <strong>+100 talented and skilled</strong>
                    <br />
                    problem-solvers
                  </span>
                </div>
              </div>
              <div className={'statistics__contact text--white'}>
                Be bold. Use our experience.&nbsp;
                <Link id={'contact-statistics'} to={'/contact#form'}>
                  Contact us.
                </Link>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

export default Statistics;
